module.exports = require("querystring");


//////////////////
// WEBPACK FOOTER
// external "querystring"
// module id = 7
// module chunks = 0